import { DragIndicator } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'

interface Props {
  selected?: boolean
  dragHandleProps?: any
  showDragIndicator?: boolean
}

export const AllocationRuleSelectedIndicator = ({ dragHandleProps, showDragIndicator }: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Stack direction='row' {...dragHandleProps}>
      <Box
        sx={{
          pt: 1.5,
          width: !showDragIndicator ? theme.customSpacing.l : undefined,
        }}
      >
        {showDragIndicator && <DragIndicator fontSize='medium' />}
      </Box>
    </Stack>
  )
}
